import React, { useEffect } from 'react';
import { Container, Form, Col, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import PropTypes from 'prop-types';
import { object, string } from 'yup';
import { SelectInput, TextInput } from '../../../Helpers/Inputs';
import StyledRadioInput from '../../../Helpers/Inputs/StyledRadioInput';
import { InputMaskDate } from '../../../Helpers/Formatters';
import States from '../../../Helpers/Lists/States';
import BasicDetails from '../../BasicDetails';
import Age from '../../../Helpers/Dates/Age';
import { customValidators } from '../../../Helpers/Validators/customValidators';
import BackNextButton from '../../../Common/BackNextButton';
import FormHeader from './FormHeader';

export default function ClientBasicInfo(props) {
  const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
    validationSchema: ClientBasicInfo.ValidationSchema(props.ageSpecs),
    mode: 'onBlur',
    reValidateMode: 'onBlur'
  });

  const handleValueChange = (field, value) => {
    setValue(field, value);
    props.onFieldChange(field, value);
    triggerValidation(field);
  };

  useEffect(() => {
    register({ name: 'clientBirthdate' });
    setValue('clientBirthdate', props.formState.clientBirthdate);

    register({ name: 'clientGender' });
    setValue('clientGender', props.formState.clientGender);

    register({ name: 'clientState' });
    setValue('clientState', props.formState.clientState);

    register({ name: 'maritalStatus' });
    setValue('maritalStatus', props.formState.maritalStatus);
  }, [register]);

  const onSubmit = () => {
    let newFormState = props.fullFormState;
    newFormState.pages.clientBasicInfo.needsLife = true;
    newFormState.pages.clientBasicInfo.needsFinalExpense = true;
    newFormState.pages.clientBasicInfo.needsEstatePlanning = true;
    newFormState.pages.clientBasicInfo.needsDI = true;
    newFormState.pages.clientBasicInfo.needsLTC = true;
    newFormState.pages.clientBasicInfo.needsIncome = false;
    newFormState.pages.clientBasicInfo.clientAge = Age(props.formState.clientBirthdate);
    //LIFE
    if (newFormState.pages.clientBasicInfo.clientAge > 95 || newFormState.pages.clientBasicInfo.maritalStatus !== 'Married') {
      newFormState.pages.clientBasicInfo.needsLife = false;
    }

    //FINAL EXPENSE
    if (newFormState.pages.clientBasicInfo.clientAge < 55 || newFormState.pages.clientBasicInfo.clientAge > 85) {
      newFormState.pages.clientBasicInfo.needsFinalExpense = false;
    }
    props.onMultiFieldChange(newFormState); 
    props.onNext();
  }

  return (
    <div>
      <Container fluid className="border-class">
        <Form onSubmit={handleSubmit(onSubmit)}>
         {props.StartOverButton}
          <Row className="justify-content-center pt-3 client-coverage">
            <Col lg={4} className='analysis-info'>
              <FormHeader title="Client's Personal Information" />
              <Form.Group>
                <TextInput
                  name="clientBirthdate"
                  id="clientBirthdate"
                  label="Date of Birth"
                  value={props.formState.clientBirthdate}
                  errors={errors && errors.clientBirthdate}
                  inputRef={register}
                  onChange={e => handleValueChange('clientBirthdate', e.target.value)}
                  InputProps={{
                    inputComponent: InputMaskDate
                  }}
                />
              </Form.Group>

              <Form.Group className='mb-0'>
                <StyledRadioInput
                  name="clientGender"
                  id="clientGender"
                  value={props.formState.clientGender}
                  options={[
                    { value: 'F', label: 'Female' },
                    { value: 'M', label: 'Male' }
                  ]}
                  inputRef={register}
                  onChange={e => handleValueChange('clientGender', e)}
                  errors={errors.clientGender}
                />
              </Form.Group>

              <Form.Group>
                <SelectInput
                  name="clientState"
                  id="clientState"
                  value={props.formState.clientState}
                  onChange={e => handleValueChange('clientState', e.target.value)}
                  label="Resident State"
                  selectOptions={States()}
                  errors={errors.clientState}
                  inputRef={register}
                  hideEmptyOption
                />
              </Form.Group>

              <Form.Group>
                <h6>Marital Status</h6>
                <StyledRadioInput
                  name="maritalStatus"
                  id="maritalStatus"
                  value={props.formState.maritalStatus}
                  options={[
                    { value: 'Single', label: 'Single' },
                    { value: 'Married', label: 'Married' }
                  ]}
                  onChange={e => handleValueChange('maritalStatus', e)}
                  errors={errors.maritalStatus}
                  inputRef={register}
                />
              </Form.Group>
            </Col>
          </Row>
          <BackNextButton onBack={props.onBack} />
        </Form>
      </Container>
      <BasicDetails
        fullFormState={props.fullFormState}
        clientBasicInfo={true}
      />
    </div>
  );
}

ClientBasicInfo.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  ageSpecs: PropTypes.object.isRequired
};

ClientBasicInfo.ValidationSchema = ageSpecs => {
  return object().shape({
    clientGender: string().required('Gender is required.'),
    clientBirthdate: customValidators.string().isValidateAgeAndDifferenceFromBirthdate('Invalid Date.', ageSpecs.min, ageSpecs.max, `Maximum age is ${ageSpecs.max}.`),
    maritalStatus: string().required('Marital Status is required.'),
    clientState: string()
      .nullable()
      .required('Resident State is required.')
  });
};

ClientBasicInfo.DefaultFormState = (prefill = false) => {
  return {
    clientBirthdate: prefill ? '05/06/1980' : '',
    clientGender: prefill ? 'M' : '',
    clientState: prefill ? 'ID' : '',
    maritalStatus: prefill ? 'S' : '',
    needsLife: false,
    needsFinalExpense: false,
    needsEstatePlanning: false,
    clientAge: null,
    needsDI: false,
    needsLTC: false,
    needsIncome: false,
  };
};



// WEBPACK FOOTER //
// ./src/components/InsuranceTools/NeedsAnalysis/steps/ClientBasicInfo.js